// extracted by mini-css-extract-plugin
export default {"authnav":"AuthNav_authnav__8U-yc","nav_link":"AuthNav_nav_link__+kibW"};